export default __webpack_public_path__ + "static/media/cigar.c56d437c.png";